import React, { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import { HeaderConfigContext } from 'app/App';
import { Modal } from 'types/modal';
import { systemActions } from 'store/system/slices';
import { ConnectorData } from '../../store/system/types';
import { StyledContent, StyledSummary } from '../AdminManagement/Groups/styles';
import { ListWithSummary, ModalWrapper } from '../../components';
import { useAppDispatch, useAppSelector } from '../../hooks/store-hooks';
import Row from './ConnectorRow';
import { useUrlParams } from '../../hooks/use-url-params';
import { useConnectorsPageState } from './hooks/use-connectors-page-state';
import { useGetConnectors } from './hooks/use-get-connectors';
import { ConnectorSummary } from './ConnectorSummary';
import { useConnectorsState } from './hooks/use-connectors-state';
import { HeaderExtra } from './HeaderExtra';
import { CreateContent } from './modal/CreateModal';
import { ConnectorBase } from './types';

const Connectors: React.FC = () => {
  const dispatch = useAppDispatch();
  const { setHeaderRenderer } = useContext(HeaderConfigContext);
  const { queryUrlParams, onPushUrlParams } = useUrlParams({});
  const { connectors, isLoading, isLoaded } = useConnectorsState();
  const { connectorsPageState, handleUpdatePageState } = useConnectorsPageState(
    connectors ? connectors.connectors : null,
    queryUrlParams
  );
  const { t } = useTranslation();
  const {
    goBack,
    location: { search },
  } = useHistory();

  useGetConnectors();

  useEffect(() => {
    setHeaderRenderer(<HeaderExtra />);
    return () => setHeaderRenderer(null);
  }, []);

  const onSelectedNode = (connector: ConnectorData) => {
    handleUpdatePageState({ connector });
    onPushUrlParams({ connector: connector.id });
  };

  const renderItem = (item: ConnectorData) => (
    <Row
      item={item}
      onItemClick={onSelectedNode}
      selectedItem={connectorsPageState.connector}
      isListLoaded={isLoaded}
    />
  );

  const onSubmitNewGroup = (data: ConnectorBase) => {
    dispatch(systemActions.connectors.requestCreateConnector(data));
    dispatch(systemActions.connectors.requestConnectors());
    goBack();
  };

  const onSubmitEditConnector = (data: ConnectorBase) => {
    dispatch(systemActions.connectors.requestUpdateConnector(data));
    dispatch(systemActions.connectors.requestConnectors());
    goBack();
  };

  return (
    <StyledContent>
      <StyledSummary>
        <ListWithSummary
          list={connectors ? connectors.connectors : null}
          isSelectedItemLoading={isLoading}
          isListLoading={isLoading}
          renderItem={renderItem}
          rowKey={(item) => `list-item-${item.id}`}
        >
          {connectorsPageState.connectors && (
            <ConnectorSummary state={connectorsPageState.connector} onSubmitEditConnector={onSubmitEditConnector} />
          )}
        </ListWithSummary>
      </StyledSummary>
      <ModalWrapper
        isVisible={search.includes(`modal=${Modal.NEW_CONNECTOR}`)}
        onClose={goBack}
        title={t('system.connectors.createTitle')}
        width={900}
        destroyOnClose
      >
        <CreateContent onSubmitForm={onSubmitNewGroup} />
      </ModalWrapper>
    </StyledContent>
  );
};

export default Connectors;
